import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  public openNotification: boolean = false;
  contentOfNotification:any='';
  closeResult: string = '';
  notifications: any;
  notificationscount: any;

  constructor(private sharedService: SharedHttpService, private router: Router,public toastr: NotificationService) {}

  ngOnInit() {
    this.getNotifications();
  }
  //getNotifications() {
  //  this.sharedService.get(`api/Notifcation/GetTop4`).subscribe(res => {
  //      this.notifications = res.top4Elemnts;
  //      if (res.countUnReaded > 0)
  //          this.notificationscount = res.countUnReaded;
  //      else
  //          this.notificationscount = "";
  //  });
  //}

  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

  showNotificationData(n,e) {
    let notification = e.target.closest('li');
  
      notification.classList.add('seen');
      this.markasread(n.notificationId);
     
    if(n.notificationCode==2){
        let url: string = `details/case/${n.eCaseId}/cases`;
      this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
        this.router.navigate([url]);
    });
        // this.router.navigate([url]);
        // window.open(url); 
    }
     if(n.notificationCode==2 && n.caseTypeId==2){
         let url: string = `/details/case/${n.eCaseId}/cases`;
      
         this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
           this.router.navigate([url]);
       });
     }
   
   
  }


    getNotifications() {
        this.sharedService.get(`api/Notifcation/GetTop4`).subscribe(res => {
            console.log(res);
            this.toastr.notifications = res.top4Elemnts;
            if (res.countUnReaded > 0)
                this.toastr.notificationscount = res.countUnReaded;
            else
                this.toastr.notificationscount = "";
        });
    }



  markasread(notificationId:any) {
      this.sharedService.get(`api/Notifcation/MakeItSeen?NotificationId=${notificationId}`,).subscribe(a => {
          this.getNotifications();
    });
  }

}
